import { render } from "./RankIcon.vue?vue&type=template&id=5e1f21c0&scoped=true&ts=true"
import script from "./RankIcon.vue?vue&type=script&lang=ts"
export * from "./RankIcon.vue?vue&type=script&lang=ts"

import "./RankIcon.vue?vue&type=style&index=0&id=5e1f21c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1f21c0"]])

export default __exports__